import React from 'react';
import ReactDOM from 'react-dom/client';
import '../src/Pages/css/others/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { DimProvider } from './context/pagecontext';
import { AuthProvider } from './context/authContext';
import { DataProvider } from './context/dataContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <DimProvider>
    <AuthProvider>
    <DataProvider>
      <App />
    </DataProvider>
    </AuthProvider>
    </DimProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
